import React, { useEffect, useState } from 'react';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-brand-darker/95 backdrop-blur-md py-4 shadow-lg shadow-black/50' : 'bg-transparent py-6'}`} data-id="element-93">
      <div className="container mx-auto px-4 md:px-6 flex items-center justify-center" data-id="element-94">
        <a href="#" className="flex items-center" data-id="element-95">
          <img src="https://cdn.magicpatterns.com/uploads/cGsijbewZbY9eY5pg7NgLx/638335839_17957120598063615_1226353128362342251_n.png" alt="Morello Detailing Logo" className="h-28 md:h-36 w-auto object-contain" data-id="element-96" />
        </a>
      </div>
    </header>;
}